module.exports = __webpack_public_path__ + "static/media/Rainfall_Tired.97bb1a33.gif";